export default "__VITE_ASSET__DuNXSDWU__";